import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Icon from "./ds/Icon";
import Tag from "./ds/Tag";
import { userService } from '../container';
import { useGlobalState } from '../state';

export default function Navigation() {
  const navigate = useNavigate();
  const { user } = useGlobalState();

  const logout = () => {
    (async () => {
      try {
        await userService.logout();

        navigate("/login", { replace: true });
      } catch (err) {
        console.log(err);
      }
    })();
  };

  function hide() {
    document.body.classList.remove('menu');
  }


  return (
    <nav id="navigation">
      <img id="logo" src="/assets/media/logo.png" width={32} height={32} />

      <div id="menu">
        <button onClick={hide}>
          <Icon icon="minus" />
        </button>

        <ul onClick={hide}>
          <li>
            <NavLink to="/">
              <Icon icon="post" />
            </NavLink>

            <Tag type="primary" label="Posts" />
          </li>

          <li>
            <NavLink to="/tags">
              <Icon icon="tag" />
            </NavLink>

            <Tag type="primary" label="Tags" />
          </li>

          <li>
            <NavLink to="/sections">
              <Icon icon="sections" />
            </NavLink>

            <Tag type="primary" label="Secciones" />
          </li>

          {user?.role === 'admin' && (
            <li>
              <NavLink to="/users">
                <Icon icon="person" />
              </NavLink>

              <Tag type="primary" label="Usuarios" />
            </li>
          )}
        </ul>
      </div>

      <NavLink to="">
        <button id="log-out" onClick={logout}>
          <Icon icon="exit" />
        </button>
      </NavLink>
    </nav>
  )
}
